module.exports = __webpack_public_path__ + "assets/img/22_383_big.d35c4191.jpg";